import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLogger from 'vuejs-logger';
import * as Keycloak from 'keycloak-js';

Vue.config.productionTip = false;
Vue.use(VueLogger);

// fetch('https://connect.bjoernbartels.earth/auth')
//   .then(function () {
let keycloak = null;
try {
    let initOptions = {
      url: 'https://connect.bjoernbartels.earth/auth', realm: 'bb-sso-demo', clientId: 'k8s-demo-serviceapp', onLoad: 'login-required'
    }
    
    keycloak = Keycloak(initOptions);

    keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {
      if (!auth) {
        window.location.reload();
      } else {
        Vue.$log.info("Authenticated");
    
        // new Vue({
        //   router,
        //   store,
        //   render: h => h(App, { props: { keycloak: keycloak } })
        // }).$mount('#app')
        
      }
    
      //Token Refresh
      setInterval(() => {
        keycloak.updateToken(70).then((refreshed) => {
          if (refreshed) {
            Vue.$log.info('Token refreshed' + refreshed);
          } else {
            Vue.$log.warn('Token not refreshed, valid for '
              + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
          }
        }).catch(() => {
          Vue.$log.error('Failed to refresh token');
        });
      }, 6000)
    
    }).catch(() => {
      Vue.$log.error("Authenticated Failed");
    });

  // })
  // .catch(function () {
  } catch (error) {
    Vue.$log.error("Keycloak init failed", error);
  } finally {
    new Vue({
      router,
      store,
      render: h => h(App, { props: { keycloak: keycloak } })
    }).$mount('#app')
  }



